import { ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DevicePilomat } from 'src/app/model/devicePilomat';
import { DeviceService } from 'src/app/service/device.service';
import { Log } from 'src/app/util/log';
import { interval, Observable, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { stateChanges } from '_node_modules/@angular/fire/database/public_api';
import { SerialsList } from 'src/app/model/serialsList';
import { DeviceState } from 'src/app/model/deviceState';

@Component({
  selector: 'app-devices-map',
  templateUrl: './devices-map.component.html',
  styleUrls: ['./devices-map.component.css']
})
export class DevicesMapComponent implements OnInit {

  // @ViewChild('devicesmaploader', { static: true }) loader;

  @Output() selected = new EventEmitter<DevicePilomat>();
  @Input() filter: string;
  @Input() deviceList: DevicePilomat[];
  selectedDevice: DevicePilomat;

  // deviceList: DevicePilomat[];
  devicesReceived: boolean = false;

  timeInterval: Subscription;

  map: google.maps.Map;
  latitude: number;
  longitude: number;
  mapZoom: number;

  subscription: Subscription;

  constructor(private deviceService: DeviceService, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
  }

  // ngOnDestroy(): void {

  //   if (this.timeInterval) {
  //     this.timeInterval.unsubscribe();
  //   }
  // }

  ngAfterViewInit() {
    // this.getDeviceList();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.deviceList) {
      if (this.deviceList.length > 0 && !this.devicesReceived) {
        Log.debug("map devices received");
        Log.debug(this.deviceList);

        this.devicesReceived = true;
        setTimeout(() => {
          this.manageMapBounds();
        }, 1500);
      }
    }

    // Log.debug("DevicesMapComponent:  Changes detected")

    // if (this.timeInterval) {
    //   this.timeInterval.unsubscribe();
    // }
    // this.startUpdatingDevicesStates();
  }


  // startUpdatingDevicesStates() {

  //   Log.debug("startUpdatingDevicesStates");

  //   let serials: SerialsList = new SerialsList();

  //   for (let i = 0; i < this.deviceList.length; i++) {
  //     serials.devices.push(this.deviceList[i].serial);
  //   }

  //   Log.debug("serials: " + JSON.stringify(serials));

  //   this.timeInterval = interval(15000).pipe(
  //     startWith(0),
  //     switchMap(() => this.deviceService.getDevicesState(serials))
  //   ).subscribe(res => this.updateDeviceIcons(res), err => Log.debug('err: ' + JSON.stringify(err)));
  // }

  // getDeviceList() {

  //   Log.debug("getDeviceList");

  //   this.loader.showLoading();

  //   this.deviceService.getDevices().subscribe(devices => {

  //     Log.debug("devices: " + JSON.stringify(devices));

  //     this.deviceList = devices;

  //     this.loader.hideLoading();

  //     this.cdRef.detectChanges();

  //     this.startUpdatingDevicesStates();
  //     this.manageMapBounds();

  //   }, error => {

  //     this.loader.hideLoading();
  //     this.loader.showError();

  //     this.cdRef.detectChanges();
  //   });
  // }

  onMarkerClicked(device) {

    Log.debug("onMarkerClicked: " + JSON.stringify(device));

    // this.selected.emit(device);
    // this.selectedDevice = device;

    // this.cdRef.detectChanges();
  }

  onInfoWindowClicked(device) {

    Log.debug("onInfoWindowClicked: " + JSON.stringify(device));

    this.selected.emit(device);
    this.selectedDevice = device;

    this.cdRef.detectChanges();
  }

  public mapReadyHandler(map: google.maps.Map): void {
    this.map = map;
  }

  public manageMapBounds() {
    const bounds: google.maps.LatLngBounds = new google.maps.LatLngBounds();
    for (const device of this.deviceList) {
      bounds.extend(new google.maps.LatLng(device.latitude, device.longitude));
    }
    this.map.fitBounds(bounds);
    setTimeout(() => {
      if (this.map.getZoom() > 20) {
        this.map.setZoom(20);
      } else if (this.map.getZoom() < 4) {
        this.map.setZoom(4);
      }
    }, 500);
  }

}

